<div class="SC-GFTCPN-mwrp">
    <button class="SC-GFTCPN-cross" [mat-dialog-close]="true" >
        <img src="assets/img/filter-close-icon.png" class="SC-GFTCPN-crossimg" alt="" />
    </button>
    <img src="assets/img/free-sc-gifticon-animte.gif" alt="" class="SC-GFTCPN-img">

    <div class="SC-GFTCPN-blbox">
        <h3 class="SC-GFTCPN-title">Wohooo {{userInfo?.firstName}}!</h3>

        <p class="SC-GFTCPN-subtitle">{{data?.giftPopupInfo?.code ?('You have won ' +data?.giftPopupInfo?.amountPercentage+'% scholarship.
            Use the below coupon code to avail exciting discount on our packages.' ):'You have successfully unlocked a special discount on SCORE - India’s No. 1 scholarship test.'}}</p>
        <!-- <p class="SC-GFTCPN-discpn">10% Discount coupon generated!</p> -->

        <div class="SC-GFTCPN-cpncd-mwrp">
            <input type="text" name="" value="Coupon: {{data?.giftPopupInfo?.code || 'INFY10'}}"  class="SC-GFTCPN-cpncd-inpbx" />
                <button type="button" (click)="copyShareUrl(data?.giftPopupInfo?.code||'INFY10')" class="SC-GFTCPN-cpncd-cpybtn"><img src="assets/img/Copy-icon.svg" alt="">
                    <div class="SC-GFTCPN-tooltip" *ngIf="showCoupon">Copied</div>
                    
                </button>
            
        </div>
        <div class="SC-GFTCPN-vald-cont">
            <img src="assets/img/success-icon.svg" alt="" class="SC-GFTCPN-vald-cont-img">
            <span class="SC-GFTCPN-vald-cont-txt">Valid till {{validDate}}</span>
        </div>
        
    </div>
    <p class="SC-GFTCPN-cpncpy">Copy the coupon code and use it while making the payment for your SCORE package</p>
      <button class="SC-GFTCPN-prcdbtn" (click)="navigateToScorePage()">REGISTER FOR SCORE</button>  
</div>
